export default __webpack_public_path__ + "static/media/about-thumb-5-challenge.ef719fe1.jpg";